(function () {
  "use strict";

  var cartApiWarmed = false;

  function lockBodyForMiniCart() {
    $("body").addClass("mini-cart-open");
  }

  function unlockBodyForMiniCart() {
    $("body").removeClass("mini-cart-open");
  }

  function warmCartApi() {
    if (cartApiWarmed || !window.fetch) return;
    cartApiWarmed = true;
    // Prime Shopify cart session so first cart interactions are faster.
    fetch('/cart.js', {
      method: 'GET',
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { 'Accept': 'application/json' }
    }).catch(function () {});
  }

  function openMiniCartDrawer() {
    warmCartApi();
    $(".mini-cart").addClass("show");
    $(".mm-fullscreen-bg").addClass("active");
    lockBodyForMiniCart();
  }

  function initMainUi() {
    if (document.documentElement.dataset.mainJsBound) return;
    document.documentElement.dataset.mainJsBound = "true";

    $('.megamenu-li').parent('ul').addClass('mega-menu');
    $('.banner-wrap').parent('ul').addClass('bottom-banner');
    $('.menu-banner').parent('ul').addClass('banner-menu');
    $('.submenu-li').parent('ul').addClass('sub-menu');
    $('.bannermenu-li').parent('ul').addClass('banner-menu');

    // Legacy newsletter-popup wiring removed: the markup is no longer rendered,
    // and it used Bootstrap 4's jQuery .modal() plugin, which throws under BS5.

    $("button.navbar-toggle").on('click', function () {
      $(".main-menu-area").addClass("active");
      $(".mm-fullscreen-bg").addClass("active");
      $("body").addClass("hidden");
    });

    $(".close-box").on('click', function () {
      $(".main-menu-area").removeClass("active");
      $(".mm-fullscreen-bg").removeClass("active");
      $("body").removeClass("hidden");
    });

    $(".shopping-cart a.cart-count").on('click', function (e) {
      e.preventDefault();
      openMiniCartDrawer();
    });

    $(document).on('click', '.shopping-cart-close', function () {
      $(".mini-cart").removeClass("show");
      $(".mm-fullscreen-bg").removeClass("active");
      unlockBodyForMiniCart();
    });

    $(".ajax-spin-cart").on('click', function () {
      // Open immediately for fast feedback; cart lines update asynchronously.
      openMiniCartDrawer();
    });

    $("button.filter-button").on('click', function () {
      $(".filter-sidebar").addClass("active");
      $(".mm-fullscreen-bg").addClass("active");
    });

    $("button.close-filter-sidebar").on('click', function () {
      $(".filter-sidebar").removeClass("active");
      $(".mm-fullscreen-bg").removeClass("active");
    });

    $(".mm-fullscreen-bg").on('click', function () {
      $(".mini-cart").removeClass("show");
      $(".main-menu-area").removeClass("active");
      $(".mm-fullscreen-bg").removeClass("active");
      $(".filter-sidebar").removeClass("active");
      $("body").removeClass("hidden");
      unlockBodyForMiniCart();
    });

    $('label.box-area').on('click', function () {
      if ($('.cust-checkbox').is(':checked')) {
        $('.agree').removeClass('disabled');
      } else {
        $('.agree').addClass('disabled');
      }
    });

    if (window.bootstrap && bootstrap.Tooltip) {
      var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
      tooltipTriggerList.forEach(function (tooltipTriggerEl) {
        new bootstrap.Tooltip(tooltipTriggerEl);
      });
    }

    $('#top').on('click', function () {
      $("html, body").animate({ scrollTop: 0 }, 0);
      return false;
    });

    if ('requestIdleCallback' in window) {
      requestIdleCallback(warmCartApi, { timeout: 1200 });
    } else {
      setTimeout(warmCartApi, 0);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMainUi);
  } else {
    initMainUi();
  }

  // Page reveal is handled earlier by an inline script in theme.liquid, so it
  // no longer waits for this deferred bundle to download + execute.

  var scrollTicking = false;
  window.addEventListener('scroll', function () {
    if (scrollTicking) return;
    scrollTicking = true;

    window.requestAnimationFrame(function () {
      var scrollTop = window.scrollY || document.documentElement.scrollTop;

      if (scrollTop > 1000) {
        $('#top').fadeIn();
      } else {
        $('#top').fadeOut();
      }

      var sticky = $('.header-bottom-wrap');
      if (scrollTop >= 150) {
        sticky.addClass('is-sticky');
      } else {
        sticky.removeClass('is-sticky');
      }

      scrollTicking = false;
    });
  }, { passive: true });
})();
